export default function NavigationIcon(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      fill="none"
      {...props}
    >
      <path
        d="M8.00004 1.33301L12.6667 13.9997L8.00004 11.333L3.33337 13.9997L8.00004 1.33301Z"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
